import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpmachinecredential0getGetScreenTruthMachineCredentialsResponseSchema = jsonObject
export type tcpmachinecredential0getGetScreenTruthMachineCredentialsResponse = z.infer<typeof tcpmachinecredential0getGetScreenTruthMachineCredentialsResponseSchema>
